<template>
    <div>
        <e-dialog
                dialog-title="份额设置"
                :center-dialog-visible="shareSetVisible"
                popup-width="520px"
                :closeBtn="true"
                cancelButtonTip="关 闭"
                buttonTip="完 成"
                @submitPopupData="handleConfirm"
                @resetPopupData="handleClose"
        >
            <el-form
                    ref="form"
                    :model="formData"
                    :rules="rules"
                    label-width="120px"
                    size="mini"
            >
                <el-form-item label="组织结构名称:" prop="businessDirection">
                    <div>{{shareData.showName}}</div>
                </el-form-item>
                <el-form-item label="份额控制方式:">
                    <el-radio-group v-model="formData.timeType" @change="changeTimeType"
                                    :disabled="shareData.handleType === 'edit'">
                        <el-radio :label="1">指定时间范围内</el-radio>
                        <el-radio :label="2">自然时间周期</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="份额控制周期:" prop="specifyTime" v-if="formData.timeType === 1">
                        <el-date-picker
                                style="width: 340px;"
                                v-model="formData.specifyTime"
                                @change="changeSpecifyTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']"
                                :disabled="shareData.handleType === 'edit'"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                </el-form-item>
                <el-form-item label="份额控制周期:" prop="naturalTimeType" v-if="formData.timeType === 2">
                    <el-select
                            v-model="formData.naturalTimeType"
                            placeholder="请选择"
                            :disabled="shareData.handleType === 'edit'"
                    >
                        <el-option
                                v-for="item in timeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="控制金额:" prop="totalAmount">
                    <el-input
                            v-model="formData.totalAmount"
                            oninput="if(!/^[1-9]\d*$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value[0];"
                            @input="formData.totalAmount = formData.totalAmount.replace( /[^0-9.]/g, '' )"
                            autocomplete="off"
                            @change="changeTotalAmount"
                    ></el-input>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="单笔金额限制:" prop="singleOrderAmount">
                    <el-input
                            v-model="formData.singleOrderAmount"
                            oninput="if(!/^[1-9]\d*$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value[0];"
                            @input="formData.singleOrderAmount = formData.singleOrderAmount.replace( /[^0-9.]/g, '' )"
                            autocomplete="off"
                            @change="changeSingleAmount"
                    ></el-input>
                </el-form-item>
                <div class="tip-wrap">
                    <p>在该周期内，每个组织结构下提交的采购订单总额不能超过控制金额。</p>
                    <p>每个订单金额不可超过单笔采购上限。</p>
                </div>
            </el-form>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/purchase';

export default {
  components: {
    eDialog,
  },
  props: {
    shareSetVisible: Boolean,
    shareData: Object
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // 获取今天的日期（清除时间部分，只保留年月日）
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          // 比较当前日期是否小于等于今天
          return time.getTime() <= today.getTime();
        },
      },
      timeList: [
        {value: 1, label: '日'},
        {value: 2, label: '周'},
        {value: 3, label: '月'},
        {value: 4, label: '季度'},
        {value: 5, label: '年'},
      ],
      formData: {
        companyList: [],
        purchaseCompanyId: '',
        purchaseCompanyName: '',
        timeType: 1, //1：指定时间范围，2：自然时间周期
        naturalTimeType: null, //1：日，2：周，3：月，4：季度，5：年
        specifyTime: [],
        specifyTimeStart: '',
        specifyTimeEnd: '',
        totalAmount: '',
        singleOrderAmount: '',
      },
      rules: {
        specifyTime: {required: true, message: '请选择份额控制周期', trigger: 'change',},
        naturalTimeType: {required: true, message: '请选择份额控制周期', trigger: 'change',},
        totalAmount: {required: true, message: '请输入控制金额', trigger: 'change',},
        singleOrderAmount: {required: true, message: '请输入单笔金额限制', trigger: 'change',},
      },
      natureDataDetail: Object,
    };
  },
  methods: {
    //价格比较
    compareValue() {
      if (Number(this.formData.singleOrderAmount) > Number(this.formData.totalAmount)) {
        this.$message.warning('单笔金额限制不能大于控制金额。')
        this.formData.singleOrderAmount = '';
      }
    },
    changeSingleAmount(val) {
      if (Number(val) > 999999999999) {
        this.$message.warning('金额仅可输入不超过12位正整数。')
        this.formData.singleOrderAmount = '';
      }
      const numArr = val.split('.');
      if (numArr.length === 2) {
        this.formData.singleOrderAmount = numArr[0]
      }
      this.compareValue();
    },
    //校验金额
    changeTotalAmount(val) {
      if (Number(val) > 999999999999) {
        this.$message.warning('金额仅可输入不超过12位正整数。')
        this.formData.totalAmount = '';
      }
      const numArr = val.split('.');
      if (numArr.length === 2) {
        this.formData.totalAmount = numArr[0]
      }
      this.compareValue();
    },
    //批量新增
    async purchaseShareBatchAdd() {
      const res = await api.purchaseShareBatchAdd(this.formData);
      if (res.code === '200') {
        this.$message.success('批量新增成功。');
        this.handleClose();
      }
    },
    //新增
    async purchaseShareAdd() {
      const res = await api.purchaseShareAdd(this.formData);
      if (res.code === '200') {
        this.$message.success('新增成功。');
        this.handleClose();
      }
    },
    //修改
    async purchaseShareModify() {
      const res = await api.purchaseShareModify(this.formData);
      if (res.code === '200') {
        this.$message.success('修改成功。');
        this.handleClose();
      }
    },
    changeSpecifyTime(val) {
      this.formData.specifyTimeStart = val[0];
      this.formData.specifyTimeEnd = val[1];
    },
    changeTimeType(val) {
      this.formData.specifyTime = '';
      this.formData.specifyTimeStart = '';
      this.formData.specifyTimeEnd = '';
      this.formData.naturalTimeType = null;
      this.formData.totalAmount = '';
      this.formData.singleOrderAmount = '';

      //自然份额
      if (this.shareData.handleType === 'leftAdd' && this.natureDataDetail.naturalTimeType && val === 2) {
        const {naturalTimeType, totalAmount, singleOrderAmount, id} = this.natureDataDetail;
        this.formData.naturalTimeType = naturalTimeType;
        this.formData.totalAmount = totalAmount;
        this.formData.singleOrderAmount = singleOrderAmount;
        this.formData.id = id;

        console.log(this.formData, 'this.formData.timeType')
      }
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.shareData.handleType === 'one') {//增加
            this.handleAdd();
          } else if (this.shareData.handleType === 'more') {//增加
            this.formData.companyList = this.shareData.companyList;
            this.purchaseShareBatchAdd();
          } else if (this.shareData.handleType === 'edit') {//修改
            this.purchaseShareModify();
          } else if (this.shareData.handleType === 'leftAdd' && this.formData.timeType === 1) {//新增
            this.handleAdd();
          } else if (this.shareData.handleType === 'leftAdd' && this.formData.timeType === 2) {//修改
            if (this.natureDataDetail.naturalTimeType) {
              this.purchaseShareModify();//有值修改
            } else {
              this.handleAdd();//没值新增
            }

          }
        }
      })
    },
    handleAdd() {
      this.formData.purchaseCompanyId = this.shareData.purchaseCompanyId;
      this.formData.purchaseCompanyName = this.shareData.purchaseCompanyName;
      this.purchaseShareAdd();
    },
    handleClose() {
      this.$emit('update:shareSetVisible', false);
    },
    //获取详情
    async purchaseShareDetail() {
      const res = await api.purchaseShareDetail({id: this.shareData.id});
      if (res.code === '200') {
        this.formData = {...this.formData, ...res.data} || {};
        if (this.formData.timeType === 1) {
          const {specifyTimeStart, specifyTimeEnd} = this.formData;
          this.formData.specifyTime = [specifyTimeStart, specifyTimeEnd];
        }
      }
    },
    //自然周期份额 详情
    async naturalShareDetail() {
      const res = await api.naturalShareDetail({purchaseCompanyId: this.shareData.purchaseCompanyId});
      if (res.code === '200' && res.data) {
        this.natureDataDetail = res.data;
      }
    },
  },
  mounted() {
    if (this.shareData.handleType === 'edit') {
      this.purchaseShareDetail();
    }
    //自然周期份额详情
    // 创建份额设置： 一进来默认是 指定
    // 指定时间范围都是   新增
    // 自然时间周期：1.有数据  -- 修改
    //               2.没数据 --  新增
    if (this.shareData.handleType === 'leftAdd') {
      this.naturalShareDetail();
    }
  },
};
</script>

<style scoped lang="scss">
.tip-wrap {
    background-color: #e8efff;
    padding: 10px 20px;
    margin-top: 10px;
    font-size: 14px;
}

::v-deep .el-input {
    width: 340px;
}
</style>
